<ng-container>
  <div class="col-8 p-0 float-left">
    @if (miniCart$ | async; as cart) {
      <a [attr.aria-label]="'miniCart.item' | cxTranslate : { count: cart?.totalItems }">
        <span class="cursor-pointer" [routerLink]="{ cxRoute: 'cartDetails', params: { code: cart?.code } } | cxUrl">
          <cx-icon [type]="iconTypes.CART"></cx-icon>
          <span class="count font-size">
            ({{ 'miniCart.count' | cxTranslate : { count: cart?.totalItems } }} {{ 'label.items' | cxTranslate }})
          </span>
          <!--   <span class="total font-size"> {{ 'miniCart.total' | cxTranslate: { total: total$ | async } }} </span> -->
        </span>
        @if (isNotCartDetailPage$ | async) {
          <span class="cursor-pointer" (click)="removeCartContext()">
            <i class="fas fa-minus-circle ml-2" aria-hidden="true"></i
            ></span>
          }
        </a>
      }
      @if (quoteContext$ | async) {
        <a [attr.aria-label]="'miniCart.item' | cxTranslate : { count: quoteQuantity$ | async }">
          <span class="cursor-pointer" (click)="redirectToQuoteDetail()">
            <span class="font-size"> <i class="fas fa-file-alt font-size-17 mr-1"></i></span>
            <span class="count font-size">
              ({{ 'miniCart.count' | cxTranslate: { count: quoteQuantity$ | async } }} {{ 'label.items' | cxTranslate }})
            </span>
            <span class="total font-size"> {{ 'miniCart.total' | cxTranslate: { total: quoteTotal$ | async } }} </span>
          </span>
          @if (isNotQuoteDetailPage$ | async) {
            <span class="cursor-pointer" (click)="removeQuoteContext()">
              <i class="fas fa-minus-circle ml-2" aria-hidden="true"></i
              ></span>
            }
          </a>
        }
        @if (!(cartContext$ | async) && !(quoteContext$ | async)) {
          <a [routerLink]="{ cxRoute: 'carts' } | cxUrl">
            <cx-icon [type]="iconTypes.CART"></cx-icon>
          </a>
        }
      </div>
    </ng-container>
